import { ELocale } from '../../../i18n/localeEnum';

export const localeEnumToRegionUuid: Partial<Record<ELocale, number>> = {
  [ELocale.EN_US]: 477,
  [ELocale.EN_GB]: 476,
  [ELocale.FR_FR]: 240,
  [ELocale.IT_IT]: 233,
  [ELocale.DE_DE]: 476,
  [ELocale.NN_NO]: 476,
  [ELocale.SV_SE]: 476,
  [ELocale.ES_ES]: 476,
  [ELocale.NL_NL]: 476,
  [ELocale.CS_CZ]: 476,
  [ELocale.PL_PL]: 476,
  [ELocale.SK_SK]: 476,
  [ELocale.DA_DK]: 476,
};

export default localeEnumToRegionUuid;
